<template>
  <div>
    <my-loader v-if="isLoading"></my-loader>
    <div v-if="company" class="post-loader">
      <div v-if="!isWizardReturn" class="button-style">
        <BackButton />
        <div>
          <button 
            :class="{'activ-button':true,'bg-activ': tabName=== 'Активность'}"  
            @click="nextTab">
            {{tabName=== 'Карточка' ? 'Активность' : 'Карточка'}}
          </button>
        </div>

      </div>

      <ExecutorWizardEditLayout
        v-if="isWizardReturn"
        title="Редактирование компании"
        description="Измените данные компании-исполнителя."
      >
        <CompanyForm
          mode="edit"
          :initial-data="company"
          :errors="formErrors"
          @update="onUpdate"
          @closeForm="closeForm"
        />
      </ExecutorWizardEditLayout>
      <div v-if="!isWizardReturn && tabName === 'Карточка'" class="cards">
        <div :class="{ 'card-item': !isWizardReturn }">
           <CompanyInfo
           :company="company" :settings="{
            chart:false,source:'apiStorage/getDatasets'
          }"/>
           <guard-button v-if="!isWizardReturn" :model="'companies'" :id="company.id"/>
        </div>
         <div v-if="company.security_info && !isWizardReturn" class="card-item">
          <CompanySecurityInfo class="securiti-info" :security="company.security_info[0]" :companyId="company.ati_id" />
        </div>
      </div>

      
      <div class="chart-container" v-if ="tabName === 'Активность' && !isWizardReturn " >
        <LineCompanyChart class="chart" v-if="datasets" :data="datasets"/>
        <div v-else><h2>Нет Данных</h2></div>
      </div>
    </div>
    
    
  </div>
</template>


<script>
import CompanyDetailTadle from '@/components/CompanyDetailTadle.vue'
import LineCompanyChart from '@/components/charts/LineCompanyChart'
import { useStore } from 'vuex'
import { ref,computed,onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import CompanySecurityInfo from '@/pages/securityCheck/components/CompanySecurityInfo.vue'
import CompanyInfo from '@/pages/securityCheck/components/CompanyInfo.vue'
import CompanyForm from '@/components/forms/CompanyForm.vue'
import ExecutorWizardEditLayout from '@/components/UI/ExecutorWizardEditLayout.vue'
import { isExecutorWizardReturn, refreshWizardItem, returnToExecutorWizard } from './executorWizardReturn'
import { useExecutorWizardStore } from '@/stores/executorWizard'



export default {
  name: 'CompanyDetail',
  components:{
    LineCompanyChart,
    CompanyDetailTadle,
    CompanyInfo,
    CompanySecurityInfo,
    CompanyForm,
     ExecutorWizardEditLayout,
  },
  setup(){
    const store = useStore()
    const tabName = ref('Карточка')
    const route = useRoute()
    const router = useRouter()
    const wizard = useExecutorWizardStore()
    const isWizardReturn = isExecutorWizardReturn(route)

    onMounted(()=>{
      store.dispatch('apiStorage/getItem',{model:'companies',params:{id:route.params.id}})
      store.dispatch('apiStorage/loadActivity',
        {model:'companies/activity',params:{id:route.params.id}}
      )
    })

    const nextTab = ()=>{
      tabName.value = tabName.value === 'Карточка' ? 'Активность' : 'Карточка'
    }

    const formErrors = computed(() => store.state.apiStorage.companies.formErrors || {})

    const onUpdate = async form => {
      const ok = await store.dispatch('apiStorage/updateItem', { model: 'companies', form })
      if (!ok) return
      await store.dispatch('apiStorage/getItem', {
        model: 'companies',
        params: { id: route.params.id },
      })
      if (isWizardReturn) {
        refreshWizardItem(wizard, route, store.state.apiStorage.companies.item)
        await returnToExecutorWizard(router)
      }
    }

    const closeForm = () => {
      if (isWizardReturn) returnToExecutorWizard(router)
    }

    return {
      tabName,
      nextTab,
      settings:computed(()=>store.state.apiStorage.settings.values),
      company:computed(()=>store.state.apiStorage.companies.item),
      isLoading:computed(() => store.state.apiStorage.companies.statusLoading),
      datasets:computed(()=>store.getters['apiStorage/getDatasets']),
      formErrors,
      isWizardReturn,
      onUpdate,
      closeForm,
    }
  }
}
</script>

<style scoped>

.button-style{
  margin-top: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  margin-left: 15px;

}

.tab-button{
  text-align: center;
  align-content: center;
  align-items: center;

}

.tab-button{
  width: 250px;
  height: 50px;
}

.tab-button:hover .icon {
  animation: rotateIcon 0.2s linear;
}

@keyframes rotateIcon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

.icon {
  transition: transform 0.3s ease;
}

.cards{
  display: flex;
  flex-direction: column;
  padding: 15px;
}

.card-item{
  border-radius: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  padding: 15px;
}

.header-content{
  display: flex;
  justify-content: flex-start;
  margin-right: 20px;
  align-items: center;
}

.activ-button {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ccc;
  padding: 2px 15px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.activ-button:hover {
  background-color: #e0e0e0;
}

.activ-button:focus {
  outline: none;
}
.bg-activ{
  background-color: #007bff;
  color: white;
}

.chart-container{
  display: flex;
  justify-content: center;

}
</style>
